
import { staffImageData } from "../assest/imgPaths";

export const staffData = [
  {
    id: 1,
    img: staffImageData.giorgiKvitivadze,
  },
  {
    id: 2,
    img: staffImageData.nataShavlakadze,
  },
  {
    id: 3,
    img: staffImageData.megiChkhetiani,
  },  
  {
    id: 4,
    img: staffImageData.tengizShavishvili,
  },
  {
    id: 5,
    img: staffImageData.anaBregadze,
  },
  {
    id: 6,
    img: staffImageData.diomidePkhakadze,
  },
  {
    id: 7,
    img: staffImageData.gvantsaIobidze,
  },
  {
    id: 8,
    img: staffImageData.guramKobakhidze,
  },
  {
    id: 9,
    img: staffImageData.davitKldiashvili,
  },
  {
    id: 10,
    img: staffImageData.titiErkomashvili,
  },
  {
    id: 11,
    img: staffImageData.giorgiDarsavelidze,
  },
];
